// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.stormwater-map-container {
  margin-top: 0 !important;
  height: 100% !important;
  padding: 0 !important;
  border-radius: 0 !important;
  width: 100% !important;
  background-color: none !important;
  box-shadow: 0px 0px 20px #000; }

.map-graphs {
  height: 50vh;
  margin-top: .5rem; }

.stormwater-map-container,
.graph-container,
.report-data-graph-container {
  margin-top: 1rem;
  padding: 1.5rem;
  background-color: #0b1736;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; }

.report-data-container {
  display: flex;
  padding-top: 0 !important;
  margin-top: -2rem;
  margin-left: 12px;
  height: 100%;
  top: 15px; }
  .report-data-container .center-dials {
    display: flex;
    align-items: center;
    padding: 4px; }
  .report-data-container .dial-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    height: 90%;
    gap: 2%; }
  .report-data-container .dial {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: white; }
    .report-data-container .dial h3 {
      font-size: 0.9rem; }

.report-data-graph-container {
  height: 100%;
  margin-right: 1vw;
  position: relative;
  background-color: #0b1736; }
  .report-data-graph-container h1 {
    color: white; }

.graph-container {
  position: relative;
  width: 98%;
  margin: 10px;
  overflow: auto; }
  .graph-container .facility-table {
    position: absolute;
    background-color: #0b1736 !important;
    top: 0; }
    .graph-container .facility-table .facility-table-head {
      position: sticky;
      top: 0;
      z-index: 100;
      background-color: #0b1736; }

.facility-table-row {
  color: white;
  cursor: pointer; }
  .facility-table-row td {
    width: 140vw; }
  .facility-table-row:hover {
    color: #0b1736;
    background-color: #ffffff87; }

.report-data-graph-container {
  width: 100% !important;
  padding: 0; }

.breadcrumb-subtitle {
  color: white; }

.cluster-marker-NSWQD {
  color: #fff;
  background: #d02222a1;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.453); }

.tab-content {
  width: 100%;
  height: 100%; }

.tab-content:last-child > .active {
  display: flex; }

.nav-link {
  color: white;
  font-size: 12px; }

.table > :not(:first-child) {
  border-top: none; }

.active-station {
  color: #0b1736 !important;
  background-color: white !important; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #nswqd-report .report-header {
    margin-top: -10rem !important; }
  canvas {
    position: absolute;
    top: 12%; } }
`, "",{"version":3,"sources":["webpack://./src/features/reports/NationalStormWaterQualityDatabase/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,6BAA6B,EAAA;;AAG/B;EACE,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;;;EAGE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C,EAAA;;AAG9C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,SAAS,EAAA;EANX;IAQI,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAA;EAVhB;IAaI,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,WAAW;IACX,OAAO,EAAA;EAjBX;IAqBI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY,EAAA;IA1BhB;MA4BM,iBAAiB,EAAA;;AAKvB;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB,EAAA;EAJ3B;IAMI,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc,EAAA;EAJhB;IAMI,kBAAkB;IAClB,oCAAoC;IACpC,MAAM,EAAA;IARV;MAUM,gBAAgB;MAChB,MAAM;MACN,YAAY;MACZ,yBAAyB,EAAA;;AAK/B;EACE,YAAY;EACZ,eAAe,EAAA;EAFjB;IAII,YAAY,EAAA;EAJhB;IAOI,cAAc;IACd,2BAA2B,EAAA;;AAI/B;EACE,sBAAsB;EACtB,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C,EAAA;;AAG9C;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AAGlB;EACE,yBAAyB;EACzB,kCAAkC,EAAA;;AAGpC;EACE;IAEI,6BAA6B,EAAA;EAIjC;IACE,kBAAkB;IAClB,QAAQ,EAAA,EACT","sourcesContent":[".report-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.stormwater-map-container {\n  margin-top: 0 !important;\n  height: 100% !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  width: 100% !important;\n  background-color: none !important;\n  box-shadow: 0px 0px 20px #000;\n}\n\n.map-graphs {\n  height: 50vh;\n  margin-top: .5rem;\n}\n\n.stormwater-map-container,\n.graph-container,\n.report-data-graph-container {\n  margin-top: 1rem;\n  padding: 1.5rem;\n  background-color: #0b1736;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.report-data-container {\n  display: flex;\n  padding-top: 0 !important;\n  margin-top: -2rem;\n  margin-left: 12px;\n  height: 100%;\n  top: 15px;\n  .center-dials {\n    display: flex;\n    align-items: center;\n    padding: 4px;\n  }\n  .dial-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-template-rows: 1fr;\n    height: 90%;\n    gap: 2%;\n  }\n  \n  .dial {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    color: white;\n    h3 {\n      font-size: 0.9rem;\n    }\n  }\n}\n\n.report-data-graph-container {\n  height: 100%;\n  margin-right: 1vw;\n  position: relative;\n  background-color: #0b1736;\n  h1 {\n    color: white;\n  }\n}\n\n.graph-container {\n  position: relative;\n  width: 98%;\n  margin: 10px;\n  overflow: auto;\n  .facility-table {\n    position: absolute;\n    background-color: #0b1736 !important;\n    top: 0;\n    .facility-table-head {\n      position: sticky;\n      top: 0;\n      z-index: 100;\n      background-color: #0b1736;\n    }\n  }\n}\n\n.facility-table-row {\n  color: white;\n  cursor: pointer;\n  td {\n    width: 140vw;\n  }\n  &:hover {\n    color: #0b1736;\n    background-color: #ffffff87;\n  }\n}\n\n.report-data-graph-container {\n  width: 100% !important;\n  padding: 0;\n}\n\n.breadcrumb-subtitle {\n  color: white;\n}\n\n.cluster-marker-NSWQD {\n  color: #fff;\n  background: #d02222a1;\n  border-radius: 50%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.453);\n}\n\n.tab-content {\n  width: 100%;\n  height: 100%;\n}\n\n.tab-content:last-child > .active {\n  display: flex;\n}\n\n.nav-link {\n  color: white;\n  font-size: 12px;\n}\n\n.table > :not(:first-child) {\n  border-top: none;\n}\n\n.active-station {\n  color: #0b1736 !important;\n  background-color: white !important;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  #nswqd-report {\n    .report-header {\n      margin-top: -10rem !important;\n    }\n  }\n\n  canvas {\n    position: absolute;\n    top: 12%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
